import { useCreateEvent } from '@/features/events/hooks/useCreateEvent';
import { EventType as NewEventType } from '@/features/events/types/EventType';
import { useEffect } from 'react';
import { saveEvent } from '../../../utils/apis/user-service';
import { EventType } from '../../../utils/enums/EventType';
import { useExpertsStore } from '../../../utils/stores/useExpertsStore';
import { useUserStore } from '../../../utils/stores/useUserStore';
import { useIsMetabolicUser } from '../../metabolic-health/hooks/useMetabolicHealth';
import { useChat } from '../hooks/useChat';
import { ChatPreview } from './ChatPreview';
import InfoBox from './InfoBox';

export const ChatList = () => {
  const { sendEvent } = useCreateEvent()
  const { userData } = useUserStore()
  const email = userData.email
  const { experts } = useExpertsStore();
  const nutritionist = experts.nutritionist;
  const physician = experts.physician
  const specialist = experts.specialist
  const admin = experts.admin;

  const isMetabolicUser = useIsMetabolicUser()
  const { isChatAvailable } = useChat()

  useEffect(() => {
    if (!email) return
    saveEvent(
      email,
      EventType.PageView,
      () => { },
      () => { },
      "chat_list_page",
    )

    void sendEvent({
      event: NewEventType.PAGE_VIEW,
      sub_category: "chats_list_page",
    })
  }, [])

  return (
    <div className="w-full h-full flex flex-col space-y-[20px] pb-[20px]">
      <div className='flex flex-col justify-between flex-1 max-w-[800px]'>
        <div className='space-y-sm'>
          {isMetabolicUser && physician && <ChatPreview expert={physician} />}
          {!isMetabolicUser && isChatAvailable && specialist && <ChatPreview expert={specialist} />}
          {nutritionist && <ChatPreview expert={nutritionist} />}
          {admin && <ChatPreview expert={admin} />}
        </div>
        <InfoBox />
      </div>
    </div>
  );
};
